<template>
    <component :is="component" :booking="booking" :form="form" :dialog="dialog" @save="onSave" @close="onClose"/>
</template>
<script>
import addAdmin from './add_admin'
import addSimple from './add_simple'
export default {
  props: ['dialog', 'form', 'booking'],
  components: {
    addAdmin,
    addSimple
  },
  data() {
    return {
      component: 'addSimple'
    }
  },
  methods: {
    onSave (result) {
      this.$emit('save', result);
    },
    onClose (result) {
      this.$emit('close', result);
    }
  },
  computed: {
    user: {
      cache: false,
      get () {
        return this.$store.getters.user
      }
    }
  },
  mounted() {
    if (this.user.role === "super" || this.user.role === "lead") {
      this.component =  'addAdmin'
    }
  }
}
</script>
<style lang="scss">

</style>
